import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;
export const visitPlanGroupRowStyleId = 'visit-plan-group-row-theme';
export const visitPlanGroupRowBridgeStyles = {
  'wb-visit-plan-group-row': {
    '--local-visit-plan-group-gap': tokens.spacing.md,
    '--local-visit-plan-group-pad-inline': tokens.spacing.xl,
    '--local-visit-plan-group-name': tokens.color.text.primary,
    '--local-visit-plan-group-name-weight': tokens.font.weight.semibold,
    '--local-visit-plan-group-muted': tokens.color.text.tertiary,
    '--local-visit-plan-group-font-size': tokens.font.size.textSm,
  },
};
